import {
  ExplicitSelectionButton,
  SafeHtmlContent
} from '@yes.technology/react-toolkit'
import { useMemo, useState } from 'react'
import { useTranslation } from 'react-i18n-lite'

import { ActivityInputProps } from '../Activity.types'
import { ActivityModelAgreement } from 'types/shared'
import { interpolateTerms, type Parameters } from 'utils/interpolate'

import styled from 'styled-components'
import useDataFromWorkflow from 'modules/interaction/hooks/useDataFromWorkflow'

const Container = styled.div``

const TermsCheckboxContainer = styled.div`
  margin: 1rem 0;
`

const Terms = styled.div`
  max-height: 400px;
  padding: 1rem;
  text-align: justify;
  text-indent: 1rem;
  border: 2px solid #abbed1;
  border-radius: 0.5rem;
`

type Props = {
  inputValue: string
  onChange: ActivityInputProps['handleChange']
  dataContainerVariable?: string
} & Pick<ActivityModelAgreement, 'terms'>

function ActivityInputAgreementTerm({
  onChange,
  inputValue,
  terms,
  dataContainerVariable
}: Props) {
  const values: Parameters = inputValue && JSON.parse(inputValue)

  const { checked = '0', ...params } = values

  const [isChecked, setIsChecked] = useState<string>(checked)

  const { t } = useTranslation()

  const { getVariableFromProcessState } = useDataFromWorkflow()

  const handleChange = () => {
    const updatedValue = isChecked === '1' ? '0' : '1'

    setIsChecked(updatedValue)
    onChange(JSON.stringify({ ...params, checked: updatedValue }))
  }

  const text =
    terms ||
    (dataContainerVariable &&
      getVariableFromProcessState(dataContainerVariable)) ||
    ''
  const interpolatedTerms = interpolateTerms(text, params)

  return (
    <Container>
      <Terms className='overflow-auto'>
        <SafeHtmlContent html={interpolatedTerms} />
      </Terms>
      <TermsCheckboxContainer>
        <ExplicitSelectionButton
          id='terms-accept'
          heightClass='semiSmall'
          direction='vertical'
          optionLabelsPosition='right'
          selectionType='uniselection'
          checkedOption={isChecked === '1' ? 'terms-accept' : ''}
          options={[
            {
              uuid: 'terms-accept',
              des: t('activity-input-agreement-term.accept')
            }
          ]}
          onChange={handleChange}
        />
      </TermsCheckboxContainer>
    </Container>
  )
}

export default ActivityInputAgreementTerm
